import { render, staticRenderFns } from "./EmailHistoryList.vue?vue&type=template&id=63011f92&scoped=true&"
import script from "./EmailHistoryList.vue?vue&type=script&lang=js&"
export * from "./EmailHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./EmailHistoryList.vue?vue&type=style&index=0&id=63011f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63011f92",
  null
  
)

export default component.exports